import React, { useState } from 'react';
import SupRestaurant from './SupervisorRestaurant';
import Order from './Order';    
import Payment from './Payment';  
import Settings from './Settings';  
import UserManagement from './UserManagementAdmin'; 
import Pickup from './Pickup'

import './css/Home.css';   


const Supervisor = () => {
  const [activeTab, setActiveTab] = useState('restaurants');  // State to track the current active tab

  // Keep instances of the components
  const renderTabContent = () => {
    switch (activeTab) {
      case 'restaurants':
        return <SupRestaurant />;
      case 'orders':
        return <Order />;
      case 'pickup':
        return <Pickup />;
      case 'payment':
        return <Payment />;
        // eslint-disable-next-line
      case 'user-management':
        return <UserManagement />;
        // eslint-disable-next-line
      case 'settings':
        return <Settings />;
      // eslint-disable-next-line
      default:
        return null;
    }
  };

  return (
    <div className="home-container">
      <div className="tab-container">
        <h2 
          className={`tab-heading ${activeTab === 'restaurants' ? 'active' : ''}`}
          onClick={() => setActiveTab('restaurants')}
        >
          My Restaurants
        </h2>
        <h2 
          className={`tab-heading ${activeTab === 'orders' ? 'active' : ''}`}
          onClick={() => setActiveTab('orders')}
        >
          Orders
        </h2>
        <h2
          className={`tab-heading ${activeTab === 'pickup' ? 'active' : ''}`}
          onClick={() => setActiveTab('pickup')}
        >
          Pick Up
        </h2>
          
        <h2 
          className={`tab-heading ${activeTab === 'payment' ? 'active' : ''}`}
          onClick={() => setActiveTab('payment')}
        >
          Payment
        </h2>
        <h2 
          className={`tab-heading ${activeTab === 'user-management' ? 'active' : ''}`}
          onClick={() => setActiveTab('user-management')}
        >
          User Management
        </h2>
        <h2 
          className={`tab-heading ${activeTab === 'settings' ? 'active' : ''}`}
          onClick={() => setActiveTab('settings')}
        >
          Settings
        </h2>
      </div>
      <div className="tab-content">
        {renderTabContent()}
      </div>
    </div>
  );
};

export default Supervisor;
